module.exports = __webpack_public_path__ + "favicon-16x16.87cafa6c.png";


//////////////////
// WEBPACK FOOTER
// ./client/containers/App/favicon-16x16.png
// module id = 639
// module chunks = 0